<template>
    <div class="md-listing-list standard" v-if="showThisModule">
        <module-box
            class="module_box"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <listing-content :recentListingTitle="cmpRecentListingTitle" />
        </module-box>
    </div>
</template>

<script>
import common from '../index';
import Content from './components/content';
// import RecentListings from './components/recent-listings'
export default {
    mixins: [common],
    components: {
        'listing-content': Content
        //   'recent-listings': RecentListings,
    }
};
</script>
